import { render } from "./footer.vue?vue&type=template&id=0fede907"
const script = {}

import exportComponent from "/Users/chaoni/ZSpace/资料/jacknichao.github.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__